import "./lowStockWidget.css";
import { useGetLowStockVariantsQuery } from "../../../services/productApi";
import { useNavigate } from "react-router-dom";
import { Inventory2Outlined } from "@mui/icons-material";
import { AdminCard, AdminSkeleton, AdminEmptyState, AdminBadge, stockVariant, stockLabel } from "../../../components/ui";

export default function LowStockWidget() {
  const { data, isLoading } = useGetLowStockVariantsQuery();
  const navigate = useNavigate();

  if (isLoading) {
    return (
      <AdminCard className="lowStockWidget">
        <h2 className="lowStockWidgetTitle">Low Stock Alerts</h2>
        <div style={{ display: "flex", flexDirection: "column", gap: 12, marginTop: 12 }}>
          {Array.from({ length: 4 }).map((_, i) => (
            <AdminSkeleton key={i} variant="text" />
          ))}
        </div>
      </AdminCard>
    );
  }

  const variants = data || [];

  return (
    <AdminCard className="lowStockWidget">
      <h2 className="lowStockWidgetTitle">Low Stock Alerts</h2>
      {variants.length === 0 ? (
        <AdminEmptyState
          icon={<Inventory2Outlined />}
          title="Everything is well stocked"
          description="No products need restocking right now."
        />
      ) : (
        <ul className="lowStockWidgetList">
          {variants.slice(0, 6).map((variant) => (
            <li key={variant.id} onClick={() => navigate(`/admin/product/edit/${variant.product}`)}>
              <span>{variant.sku || `Variant #${variant.id}`}</span>
              <AdminBadge variant={stockVariant(variant.stock_quantity)}>
                {stockLabel(variant.stock_quantity)}
              </AdminBadge>
            </li>
          ))}
        </ul>
      )}
    </AdminCard>
  );
}
